export const REQUEST_PROFILE_TAB_DOCUMENTS_BREADCRUMB_REQUEST = 'request'

export const QA_NAME_REQUEST_PROFILE_TAB_DOCUMENTS = 'request_profile_documents'

export const NO_RELATED_REQUESTS_TOOLTIP_KEY =
  'RequestProfileTabDocuments.NoRelatedRequestsTooltipKey'
